import React, {useState} from "react";
import _ from "lodash";
import { useEffect } from "react";
import api from "api";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { AvatarVertical2 } from "component/Avatar";
import "./index.scss";
import { Link } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { FollowButton } from "component/Follow";

const OfficialAccountSlider = (props) => {
    const [isEOF, setIsEOF]             = useState(false);
    const [isLoading, setIsLoading]     = useState(true);
    const [Talents, SetTalents] = useState(props.accounts || false);

    const [listArgs, setListArgs]       = useState(_.assignIn({}, {
        posts_per_page : 5
        ,paged : 1
    }, props.list_args) || {});

    useEffect(() => {
        if( !_.isUndefined(props.accounts) )
        {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        
        api('/OfficialAccount', 'post', listArgs).then(response => {
            setIsLoading(false);

            if(response.account.length < listArgs.posts_per_page)
            {
                setIsEOF(true);
            }

            if(Talents !== false)
            {
                SetTalents( Talents.concat(response.account));
            }
            else
            {
                SetTalents(response.account);
            }
            
        })
        .catch(() => {
            setIsLoading(false);
            setIsEOF(true);
        })

    }, [listArgs]);

    return(
        <div className="component-official-account -slider">
            <Splide options={{
                autoWidth : true
                ,pagination : false
                ,arrows : false
            }}>
                <ul className="the-talents">
                    {
                        Talents !== false && Talents.map((User) => (
                            <SplideSlide key={User.UserID}>
                                <div className="the-talent" >
                                    <div className="talent-card text-center">
                                        <div>
                                            <AvatarVertical2 user={ _.assignIn({}, User, {
                                                disable_user_card : true
                                            }) }/>
                                        </div>
                                        <div className="follow-button">
                                            <FollowButton className="btn-mini btn-orange btn" user={User}/>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                        ))
                    }
                    {
                        isLoading && 
                        <SplideSlide>
                            <div className="the-talent">
                                <div className="talent-card">
                                    <div className="card-skeleton talent-card-wrapper relative">
                                        <span className="skeleton"></span>
                                    </div>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                </ul>
            </Splide>
            {
                Talents !== false && Talents.length == 0 &&
                <div className="text-sm text-center bold block mt-4 mb-4">

                </div>
            }
        </div>
    )

}

const OfficialAccountList = connect(stateMap)((props) => {
    const [isEOF, setIsEOF]             = useState(false);
    const [isLoading, setIsLoading]     = useState(true);
    const [Talents, SetTalents] = useState(props.accounts || false);

    const [listArgs, setListArgs]       = useState(_.assignIn({}, {
        posts_per_page : 5
        ,paged : 1
    }, props.list_args) || {});

    useEffect(() => {
        if( !_.isUndefined(props.accounts) )
        {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        api('/OfficialAccount', 'post', listArgs, ).then(response => {
            setIsLoading(false);

            if(response.account.length < listArgs.posts_per_page)
            {
                setIsEOF(true);
            }

            if(Talents !== false)
            {
                SetTalents( Talents.concat(response.account));
            }
            else
            {
                SetTalents(response.account);
            }
            
        })
        .catch(() => {
            setIsLoading(false);
            setIsEOF(true);
        })

    }, [listArgs]);

    return(
        <div className="component-official-account">
            <ul className="the-talents">
                {
                    Talents !== false && Talents.map((User) => (
                        <li className="the-talent" key={User.UserID}>
                            <div className="talent-card text-center">
                                <div>
                                    <AvatarVertical2 user={User}/>
                                </div>
                                <div className="follow-button">
                                    <FollowButton className="btn-mini btn-orange btn" user={User}/>
                                </div>
                            </div>
                        </li>
                    ))
                }
                {
                    isLoading && 
                    <li className="the-talent">
                        <div className="talent-card">
                            <div className="card-skeleton talent-card-wrapper relative">
                                <span className="skeleton"></span>
                            </div>
                        </div>
                    </li>
                }
                {
                    Talents !== false && Talents.length == 0 &&
                    <li className="the-talent">
                        <div className="talent-card">
                            <div className="card-not-found talent-card-wrapper relative">
                                <span className="text-center bold block mt-4">
                                    No User Found
                                </span>
                            </div>
                        </div>
                    </li>
                }
            </ul>
        </div>
    )
})

export {OfficialAccountList, OfficialAccountSlider}